// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import More from '../_raw/ui/icon_more.svg';
import withIconProps from '../withIconProps';

export default withIconProps(More);
